import UpdatePrompt from './UpdatePrompt';

export default UpdatePrompt;

